import React from "react";
import { useForm } from "react-hook-form";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions/allActions";
import { FormRadio } from "../../../components/form/FormRadio";
import { selectFormInputValues } from "../../../reducers/formReducer";
import * as erState from "../../../reducers/errorReducer";
import ErrorFetching from "../../../components/modals/ErrorFetching";
import { useNotify } from "../../../hooks/useNotify";
import { useFormatMessage } from "../../../utils/functions";

interface SelectRegistrationFormProps {
  formName: string;
  formAction: (data: { RegistrationType: string }) => void;
}

export const SelectRegistrationForm: React.FC<SelectRegistrationFormProps> = ({
  formName,
  formAction,
}) => {
  const dispatch = useDispatch();
  const { register, handleSubmit, errors } = useForm();
  const { message } = useSelector(erState.getErrorMessage);
  const errorMsg = useNotify(message);
  const formState = useSelector((state) =>
    selectFormInputValues(state, formName)
  );
  const styles = "w-full";
  const inputContainers = "w-1/3";
  const registrationTypeId = "RegistrationType";
  const registrationValue = formState[registrationTypeId] as string;

  const handleInputChange = (event: any, id: string, type?: string) => {
    if (type === "array") {
      const currentValue = formState[id];
      const newArray =
        currentValue === undefined
          ? []
          : typeof currentValue === "string"
          ? [currentValue]
          : currentValue;
      dispatch(
        allActions.formActions.addToValue(
          id,
          newArray,
          event.target.value,
          formName
        )
      );
    } else {
      dispatch(
        allActions.formActions.updateValue(id, event.target.value, formName)
      );
    }
  };

  const buttonInfo = {
    style:
      "bg-blue-400 hover:bg-brand-blue text-center text-brand-white py-2 px-4 rounded m-5 ml-32",
    format_id: "RegistrationMethod.confirm_button",
  };

  return (
    <form className={styles} onSubmit={handleSubmit(formAction)}>
      <FormRadio
        id={registrationTypeId}
        question={useFormatMessage("ChooseRegistration.header")}
        cursiveLabel={useFormatMessage("ChooseRegistration.description")}
        handleInputChange={handleInputChange}
        containerStyle={inputContainers}
        options={[
          useFormatMessage("RegistrationType_option1"),
          useFormatMessage("RegistrationType_option2"),
        ]}
        register={register}
        errors={errors}
        checked={registrationValue}
      />
      <ErrorFetching message={errorMsg} />
      <div>
        <button type='submit' className={buttonInfo.style}>
          <FormattedMessage id={buttonInfo.format_id} />
        </button>
      </div>
    </form>
  );
};

export default SelectRegistrationForm;
